const steps = [
  {
    n: "01",
    icon: "ri-link",
    title: "找到目标网页",
    desc: "复制任意公开网页的链接，无论是长图文、讨论帖还是资讯页，都能直接作为处理对象。",
  },
  {
    n: "02",
    icon: "ri-checkbox-circle-line",
    title: "选择提取方向",
    desc: "根据目的勾选文字、图片、视频、链接或源码。也可切换源码模式，查看页面结构与素材来源。",
  },
  {
    n: "03",
    icon: "ri-file-copy-line",
    title: "复制并归档",
    desc: "解析完成后，一键复制正文、链接清单或图片直链，自行整理到笔记与收藏夹，随用随取。",
  },
];

export default function Steps() {
  return (
    <section id="steps" className="section-pad scroll-mt-20 bg-background-50">
      <div className="container-x">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-sm font-medium tracking-wide text-primary-600">上手流程</p>
          <h2 className="mt-2 font-heading text-3xl text-foreground-900 md:text-4xl">三步开始，无需学习成本</h2>
        </div>

        <div className="relative mt-12 grid gap-6 lg:grid-cols-3">
          <div className="pointer-events-none absolute left-0 right-0 top-10 hidden h-px bg-gradient-to-r from-transparent via-background-300 to-transparent lg:block" />
          {steps.map((s) => (
            <article
              key={s.n}
              className="relative rounded-2xl border border-background-200/80 bg-background-50 p-6"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-accent-500 text-background-50">
                  <i className={`${s.icon} text-xl`} aria-hidden="true" />
                </span>
                <span className="font-heading text-5xl text-background-200">{s.n}</span>
              </div>
              <h3 className="mt-5 text-lg font-bold text-foreground-900">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-8 flex flex-col gap-4 rounded-2xl bg-background-100 p-6 md:flex-row md:items-center">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-secondary-500 text-background-50">
            <i className="ri-shield-check-line text-xl" aria-hidden="true" />
          </span>
          <div className="flex-1">
            <p className="text-sm font-bold text-foreground-900">合规使用提醒</p>
            <p className="mt-1 text-xs leading-relaxed text-foreground-600 md:text-sm">
              吃瓜网页仅面向公开、可正常访问的网页提供提取能力。请尊重原作者版权与各平台的用户协议，
              提取内容请注明出处，不要用于批量采集、搬运或商用侵权。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}